import React from "react";

import {
  ActionIcon,
  Button,
  Group,
  Text,
  UnstyledButton,
  createStyles,
  getStylesRef,
} from "@mantine/core";

import { IconMail } from "@tabler/icons-react";

const useStyles = createStyles((theme) => ({
  mybutton: {
    backgroundcolor: "var(--app-tint-primary)",

    [`&:hover .${getStylesRef("btnText")}`]: {
      background: "var(--app-primary)",
    },
    [`&:hover .${getStylesRef("btnIcon")}`]: {
      background: "var(--app-primary)",
    },
  },
  btnIcon: {
    ref: getStylesRef("btnIcon"),
    background: "var(--app-tint-primary)",
    borderRadius: 5,
    borderColor: "var(--app-primary)",
    borderStyle: "solid",
    padding: 10,
  },
  btnText: {
    ref: getStylesRef("btnText"),
    backgroundColor: "var(--app-tint-primary)",
    borderTopColor: "var(--app-primary)",
    borderBottomColor: "var(--app-primary)",
    borderRightColor: "var(--app-primary)",
    borderTopStyle: "solid",
    borderRightStyle: "solid",
    borderBottomStyle: "solid",
  },
}));

const ReportButton = ({ title, onClick, loading }) => {
  const { classes } = useStyles();
  return (
    <UnstyledButton className={classes.mybutton} onClick={onClick}>
      <Group spacing={0}>
        <IconMail
          color="black"
          stroke={1}
          className={classes.btnIcon}
          size={48}
        />
        <Text
          sx={{
            fontFamily: "Inter",
            fontSize: 16,
            fontWeight: 500,
            borderTopRightRadius: 5,
            borderBottomRightRadius: 5,
            zIndex: -1,
          }}
          className={classes.btnText}
          p={7}
          ml={-3}
        >
          {title}
        </Text>
      </Group>
    </UnstyledButton>
  );
};

export default ReportButton;
